// extracted by mini-css-extract-plugin
module.exports = {"suggestion":"Suggestion_suggestion__2rT0C","dark":"Suggestion_dark__2xcNG","light":"Suggestion_light__C-sPQ"};